import { DocumentModel } from 'shared/domain/document/documentModel';
import { addToHashMap } from 'helpers/mappings';
import { modifiedAtSort } from 'helpers/sort';
import { HashMap } from 'shared/types/commonView';
import { documentModelToDocumentOnView } from './documentModelToDocumentOnView';
import { DocumentOnView } from './documentOnView';
import { isDocumentRemoteAndUnavailable } from './documentRemoteAndUnavailable';

export type DocumentsOnInspectionView = HashMap<DocumentOnView[]>;

export function documentsToDocumentsOnInspectionView(
  documents: DocumentModel[]
): DocumentsOnInspectionView {
  const inspectionDocuments: HashMap<DocumentOnView[]> = {};

  documents.sort(modifiedAtSort).forEach((document) => {
    if (document.deleted) {
      return;
    }

    if (isDocumentRemoteAndUnavailable(document)) {
      return;
    }

    const documentOnInspectionView =
      documentModelToDocumentOnView(document);
    if (!documentOnInspectionView) {
      return;
    }

    if (document.protocolId) {
      addToHashMap(
        inspectionDocuments,
        documentOnInspectionView,
        document.protocolId
      );
    }

    // Protocol section documents (added during inspection, keyed by sectionId)
    // Note: sectionId here refers to protocol section ID, not template section ID
    if (document.sectionId && document.inspectionId && !document.templateId) {
      addToHashMap(
        inspectionDocuments,
        documentOnInspectionView,
        document.sectionId
      );
    }
  });

  return inspectionDocuments;
}
